import { combineReducers, configureStore, createAction } from '@reduxjs/toolkit';
import { companyReducer } from 'dashboard409a/states/features/company';
import { globalReducer } from 'dashboard409a/states/features/global';
import { userReducer } from 'dashboard409a/states/features/user';
import { dashboardReducer as valuationReducer } from 'dashboard409a/states/features/valuation';
import { waterfallReducer } from 'dashboard409a/states/features/waterfall';

const dashboardReducer = combineReducers({
  company: companyReducer,
  global: globalReducer,
  user: userReducer,
  valuation: valuationReducer,
  waterfall: waterfallReducer,
});

export const resetDashboardState = createAction('dashboard/resetState');

const rootReducer: typeof dashboardReducer = (state, action) =>
  dashboardReducer(resetDashboardState.match(action) ? undefined : state, action);

const store = configureStore({
  reducer: rootReducer,
});

export type RootStateType = ReturnType<typeof store.getState>;
export type AppDispatchType = typeof store.dispatch;

export default store;
